<template>
  <el-dialog
    title="请选择合伙人类型"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="420px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-select
      v-model="zsDealerId"
      style="width: 100%"
      placeholder="请选择">
      <!-- <el-option
        v-if="type !== 'up'"
        label="普通合伙人"
        :value="null"></el-option> -->
      <el-option
        v-for="(item, index) in list"
        :key="index"
        :label="item.dealerName"
        :value="item.dealerId">
      </el-option>
    </el-select>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'PartnerAuditModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      zsDealerId: null,
      list: [],
      option: {},
      type: 'add'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.option = {}
      this.type = 'add'
    },
    handleSubmit() {
      if (this.type === 'add') {
        this.aduit()
      } else {
        this.upgrade()
      }
    },
    aduit() {
      this.loading = true
      const row = this.option
      this.$store.dispatch('agent/auditagent', {
        payload: {
          agentId: row.agentId,
          vendorId: row.vendorId,
          pass: 1,
          zsDealerId: this.zsDealerId
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    upgrade() {
      this.loading = true
      const row = this.option
      this.$store.dispatch('agent/bindzsdealer', {
        payload: {
          vendorId: row.vendorId,
          agentId: row.agentId,
          zsDealerId: this.zsDealerId
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('agent/getbindablezsdealers', {
        payload: {
          pageNum: 1,
          pageSize: 1000
        },
        success: (res) => {
          this.loading = false
          if (this.type === 'up') {
            if (res.data.records.length > 0) {
              this.zsDealerId = res.data.records[0].dealerId
            } else {
              this.$message.error('暂无可用经销商')
              return
            }
          }
          this.list = res.data.records
          cb && cb(res.data.records)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(option, type) {
      this.option = {
        ...this.option,
        ...option
      }
      this.type = type || 'add'
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
